import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Tag, X } from "lucide-react";

export const discountText = (d) =>
  d.discount_type === "percent" ? `-${d.value}%` : `-€${Number(d.value).toFixed(2).replace(".", ",")}`;

export const DiscountCodeField = ({ discount, onChange }) => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const apply = async () => {
    if (!code.trim()) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/payments/validate-discount", { code });
      onChange(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  if (discount) {
    return (
      <div className="flex items-center justify-between gap-2 rounded-xl border border-primary/30 bg-primary/10 px-3 py-2 text-sm" data-testid="discount-applied">
        <span className="flex items-center gap-2 min-w-0">
          <Tag className="h-4 w-4 text-primary shrink-0" />
          <span className="truncate"><b>{discount.code}</b> · {discount.label || "Sconto"} ({discountText(discount)}{discount.duration === "once" ? " sul primo pagamento" : " su ogni rinnovo"})</span>
        </span>
        <button onClick={() => { onChange(null); setCode(""); }} className="text-muted-foreground hover:text-foreground" data-testid="discount-remove-button" aria-label="Rimuovi codice">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="space-y-1">
      <div className="flex gap-2">
        <Input value={code} onChange={(e) => setCode(e.target.value.toUpperCase())} placeholder="Hai un codice sconto?"
          onKeyDown={(e) => e.key === "Enter" && apply()} className="h-10" data-testid="discount-code-input" />
        <Button variant="outline" className="h-10" onClick={apply} disabled={busy || !code.trim()} data-testid="discount-apply-button">
          {busy ? "Verifica…" : "Applica"}
        </Button>
      </div>
      {error && <p className="text-xs text-destructive" data-testid="discount-error">{error}</p>}
    </div>
  );
};
